import { Container, Flex } from "@radix-ui/themes";
import { ErrorBoundary } from "@sentry/react";
import { PropsWithChildren, Suspense } from "react";
import { FullSpinner } from "../shared/components/full-spinner";
import { HeaderWhenEmbedded } from "../shared/components/header-with-menu";
import { NotFoundOrIntermittentError } from "../shared/components/not-found-or-intermittent-error";
import { MapHeader } from "./components/map-header.component";
import { useMapEmbedParams } from "./use-map-embed-params";

export const MapRoot: React.FC<PropsWithChildren> = ({ children }) => {
  const { isEmbedded } = useMapEmbedParams();

  return (
    <Container size="1" p="2" height="calc(100dvh - 2 * var(--space-2))">
      <Flex direction="column" style={{ height: "100%" }}>
        <ErrorBoundary fallback={<NotFoundOrIntermittentError />}>
          <Suspense fallback={<FullSpinner />}>
            {isEmbedded ? (
              <HeaderWhenEmbedded title="Stationen" />
            ) : (
              <MapHeader />
            )}
            <Flex direction="column" flexGrow="1">
              <Suspense fallback={<FullSpinner />}>{children}</Suspense>
            </Flex>
          </Suspense>
        </ErrorBoundary>
      </Flex>
    </Container>
  );
};
